import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  return (
    <nav className="bg-background shadow-custom-soft rounded-lg text-darkText p-3 px-5 w-full">
      <div className="flex justify-between items-center">
        <h1 className="uppercase font-fw_600">FF Low Code</h1>
        <button
          onClick={() => {
            localStorage.removeItem("accessToken");
            navigate("/");
          }}
          className="bg-primary text-white px-4 py-1 rounded-md"
        >
          Logout
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
